import React from 'react';
import styled from '@emotion/styled';
import css from '@emotion/css';
import { device } from './../../../../components/Print/device';
import { doNotAppendUrlIfEmpty } from 'components/ToiSubscription/utils/redirectionToPlanPage';

interface ITabData {
  name: string;
  href: string;
}

interface IStyledTabs {
  state?: string;
  isWapView: boolean;
}

interface IEpaperTabsProps {
  data: ITabData[];
  isWapView: boolean;
}

export const EpaperTabs: React.FC<IEpaperTabsProps> = ({ data, isWapView }) => {
  const onClickHandler = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, innerData: ITabData) => {
    e.preventDefault();
    if (innerData.name === 'Digital View') {
      return;
    }
    const currUrlObj = new URL(window.location.href);
    const utmSource = currUrlObj.searchParams.get('utm_source') || null;
    const utmMedium = currUrlObj.searchParams.get('utm_medium') || null;
    const utmCampaign = currUrlObj.searchParams.get('utm_campaign') || null;
    const frmapp = currUrlObj.searchParams.get('frmapp') || null;
    const iosver = currUrlObj.searchParams.get('iosver') || null;
    const andver = currUrlObj.searchParams.get('andver') || null;
    window.location.href = doNotAppendUrlIfEmpty(innerData.href, ['frmapp', 'utm_source', 'utm_medium', 'utm_campaign', 'andver', 'iosver'], [frmapp, utmSource, utmMedium, utmCampaign, andver, iosver]);
  }
  return (
    <TabWrapper id="tabs">
      <Tab>
        {Array.isArray(data) &&
          data.map((innerData: ITabData) => {
            return (
              <TabList key={innerData.name} state={innerData.name === 'Digital View' ? 'active' : ''} isWapView={isWapView}>
                <a href={innerData.href} onClick={(e) => onClickHandler(e, innerData)}>{innerData.name}</a>
              </TabList>
            );
          })}
      </Tab>
    </TabWrapper>
  );
};

const TabWrapper = styled.div` 
  @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    order: 3;
    flex: 1 0 100%;  
    padding: 12px 0;
    margin: 0 0 5px;
    background: #fff;
  }
`;

const Tab = styled.ul`
  padding: 2px;
  border-radius: 100px;
  //border: solid 1px #e4e4e4;
  background-color: #f4f4f4;
  margin: 4px 0;
  @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
    margin: 0 24px;
    display: flex;
  }
`;

const TabList = styled.li<IStyledTabs>`
  display: inline-block;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  
  a {
    color: #000;
    padding: 6px 0;
    min-width: 140px;
    line-height: 16px;
    display: inline-block;
    
    @media screen and (max-width: 360px) {
       min-width: 114px;
    }
  }
  
  // @media screen and (device-width: 768px) and (device-height: 1024px) and (orientation:portrait) {
    @media screen and (max-width: 1024px) {
    font-size: 12px;
    a{
      min-width: 100px;
    }
  }

  @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
    width: 50%;
    min-width: auto;
    font-size: 11px;
    line-height: 16px;
    font-weight: 500;
    ${(props: IStyledTabs) => props.state === 'active' && css`
      font-weight: bold;
    `}
  }
  ${(props: IStyledTabs) => props.state === 'active' && css`
      border-radius: 100px;
      background-color: #e21b23;
      font-weight: bold;
      a {
        color: #fff;
      }
    `}
`;
